import { LEGAL_UPDATED, type LegalDocument } from '../../shared/legal';

export function LegalPage({ document }: { document: LegalDocument }) {
  return (
    <main id="main-content" className="legal-page">
      <a className="back-link" href="/">
        Back to calendar
      </a>
      <article>
        <h1>{document.title}</h1>
        <p className="legal-updated">Last updated {LEGAL_UPDATED}</p>
        <p>{document.introduction}</p>
        {document.sections.map((section) => (
          <section key={section.title}>
            <h2>{section.title}</h2>
            {section.paragraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </section>
        ))}
      </article>
      <nav aria-label="Policies">
        <a href="/privacy">Privacy Policy</a>
        <a href="/terms">Terms of Use</a>
      </nav>
    </main>
  );
}
